.root {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// Responsive thumbnail grid — squares that reflow to the container width and
// never overflow on narrow screens.
.thumb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  gap: 8px;
}

.thumb {
  aspect-ratio: 1 / 1;
  padding: 0;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  overflow: hidden;
  background: var(--color-muted-background, #f9fafb);
  cursor: pointer;
  transition: border-color 0.15s;

  &:hover {
    border-color: var(--color-foreground, #111827);
  }
}

.thumb-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumb-broken {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--color-muted, #6b7280);
}

.file-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  color: var(--color-foreground, #111827);
  text-decoration: none;
  font-size: 13px;

  &:hover {
    background: var(--color-muted-background, #f9fafb);
  }
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
